import { TemplateList } from "@/components/TemplateList";

const Templates = () => {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-bold tracking-tight">Template Management</h1>
        <p className="text-muted-foreground">Create and manage smart templates for clinical documentation.</p>
      </div>
      <TemplateList />
    </div>
  );
};

export default Templates;
